var exports = {
  "v5": "dialogBody__PkzyLg",
  "Zd": "form__DWVkAY",
  "DD": "title__HCekFm",
  "nl": "dialogTitle__qTsrin",
};

module.exports = exports;
